import { render } from "./SupplierDataList.vue?vue&type=template&id=9bc49cfe&scoped=true"
import script from "./SupplierDataList.vue?vue&type=script&lang=js"
export * from "./SupplierDataList.vue?vue&type=script&lang=js"

import "./SupplierDataList.vue?vue&type=style&index=0&id=9bc49cfe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bc49cfe"]])

export default __exports__